import { DataCollection } from "@app/classes/infrastructure/datacollection";
import { DataContainerService } from "@app/classes/infrastructure/datacontainer.service";
import { RequestTypes } from "@app/classes/infrastructure/enums";
import { TransportData } from "@app/classes/infrastructure/transportdata";
import { Utils } from "@app/services/utils.service";


export class FinancialYearMasterFetchRequest {
    public static readonly FetchRequestType: string = "financial_year_master_fetch_request";
    financial_year_ids: number[] = [];

    public MergeIntoTransportData = (td: TransportData) => {
        let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, FinancialYearMasterFetchRequest.FetchRequestType) as DataCollection;
        coll.Entries.push(this);
    }

    public FormulateTransportData = () => {
        let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
        this.MergeIntoTransportData(td);

        return td;
    }
}

